require.register("modules/m0x/a02/page-11-il/page-11-il", function(exports, require, module){
  var BaseExtension = require('base-extension');

var page11_il = _.defaults({
  initialized: function(view) {

  },
  loaded: function(view) {

  },
  playing: function(view) {

  },
  paused: function(view) {

  },
  stopped: function(view) {

  },
  completed: function(view) {
  },
  unloading: function(view, onComplete) {

    onComplete();
  }
}, BaseExtension);

module.exports = page11_il;

  
});

